'use strict';

exports.__esModule = true;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.getStore = getStore;

var _redux = require('redux');

var _reducer = require('../reducer');

var _plugins = require('../plugins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
  return f;
};

var defaultOptions = {
  paths: ['kea', 'scenes'],
  middleware: [],
  compose: [reduxDevTools],
  reducers: {}
};

function getStore() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // clone options
  var options = (0, _assign2.default)({}, defaultOptions, opts);

  // clone reducers
  options.reducers = (0, _assign2.default)({}, options.reducers);
  options.paths.forEach(function (path) {
    options.reducers[path] = (0, _reducer.keaReducer)(path);
  });

  // run pre-hooks
  _plugins.installedPlugins.forEach(function (plugin) {
    plugin.beforeReduxStore && plugin.beforeReduxStore(options);
  });

  var finalCreateStore = void 0;

  // combine middleware
  if (options.middleware.length > 0) {
    options.compose = [_redux.applyMiddleware.apply(undefined, options.middleware)].concat(options.compose);
  }

  if (options.compose.length > 0) {
    finalCreateStore = _redux.compose.apply(undefined, options.compose)(_redux.createStore);
  } else {
    finalCreateStore = _redux.createStore;
  }

  // combine reducers
  var combinedReducers = (0, _redux.combineReducers)(options.reducers);

  // create store
  var store = finalCreateStore(combinedReducers);

  // run post-hooks
  _plugins.installedPlugins.forEach(function (plugin) {
    plugin.afterReduxStore && plugin.afterReduxStore(options, store);
  });

  return store;
}


//////////////////
// WEBPACK FOOTER
// ./~/kea/es/kea/store/index.js
// module id = 828
// module chunks = 2